<template>
  <div>
    <div class="d-flex flex-column centered w-100 mw-100">
      <div class="div-logo">
        <img
          :src="'/static/icons/ruejai-app-logo-optimize.png'"
          class="w-100"
        />
      </div>
      <div class="div-button">
        <el-button
          type="primary"
          @click="handleOpenApp"
          >{{ labelOpenApp }}</el-button
        >
      </div>
      <div class="div-button">
        <el-button
          type="primary"
          @click="handleOpenStore"
          >{{ labelOpenStore }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Button } from "element-ui";
import qs from "qs";

export default {
  components: {
    "el-button": Button
  },
  data: function() {
    return { 
      labelOpenApp: 'Open App',
      labelOpenStore: 'Download App'
    }
  },
  mounted: function() {
    const language = navigator.language.toLowerCase()
    if(language !== undefined && language.match('th')) {
      this.labelOpenApp = 'เปิดแอป'
      this.labelOpenStore = 'ดาวน์โหลดแอป'
    } else {
      this.labelOpenApp = 'Open App'
      this.labelOpenStore = 'Download App'
    }
  },
  computed: {
    openStoreURL() {
      const url = navigator.userAgent.includes("Android")
        ? "https://play.google.com/store/apps/details?id=com.fireoneone.baanruejai"
        : navigator.userAgent.includes("iPhone") ||
          navigator.userAgent.includes("iPad")
        ? "https://apps.apple.com/us/app/baan-ruejai/id1375938415"
        : "https://ruejaiclub.com";

      return url;
    },
    openAppURL() {
      const queryParams = this.$route.query;
      const queryString = qs.stringify(queryParams, {
        addQueryPrefix: true
      });

      const url = navigator.userAgent.includes("Android")
        ? `intent://sc.ruejai.app/content${queryString}#Intent;scheme=ruejai-app;package=${process.env.ANDROID_APP_PACKAGE_NAME};end`
        : navigator.userAgent.includes("iPhone") ||
          navigator.userAgent.includes("iPad")
        ? `${process.env.APPLE_APP_BUNDLE_ID}://www.scasset.com/baanruejai/content${queryString}`
        : "https://ruejaiclub.com";

      return url;
    }
  },
  methods: {
    handleOpenApp() {
      window.open(this.openAppURL, "_self");
    },
    handleOpenStore() {
      window.open(this.openStoreURL, "_self");
    }
  }
};
</script>

<style lang="scss" scoped>
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.div {
  &-button {
    width: 60%;
    max-width: 60%;
    margin-top: 5%;
    margin-left: 20%;
    margin-right: 20%;
  }

  &-logo {
    width: 60%;
    max-width: 60%;
    margin-left: 20%;
    margin-right: 20%;
  }
}
.el-button {
  font-weight: bold;
  width: 100%;
  background-color: $orange;
  border-color: $orange;
}
</style>



// WEBPACK FOOTER //
// src/components/general/Content.vue